import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GuiZoneService, NotificationsService} from '@catcore/services';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {StyleType} from '@catui/types';
import {SelectItem} from 'primeng/primeng';

interface ListItem {
  label: string;
  raw: string;
}

@Component({
  selector: 'catapp-add-gui-zone',
  templateUrl: './add-gui-zone.component.html',
  styleUrls: ['./add-gui-zone.component.scss'],
})
export class AddGuiZoneComponent implements OnInit {

  @Output() afterAdd = new EventEmitter();

  selectableZones: SelectItem[] = [];
  styleType = StyleType;

  availableZones: any;
  children: ListItem[];
  parents: ListItem[];
  affectedZone: any;

  private currentSelection: string = null;

  constructor(private _guiZoneService: GuiZoneService,
              private _notification: NotificationsService,
              private _activeModal: ActiveModal) {
  }

  /**
   * Once the component gets initialized the applicable zones will be collected
   * and provided to the dropdown.
   */
  ngOnInit() {
    this.selectableZones = this.buildSelectableZones();
  }

  /**
   * Callback whenever the drop down selection changed.
   *
   * @param event Event including the current value
   */
  selectionChanged(event) {
    this.currentSelection = event.value;
  }

  /**
   * Returns true if a zone has been selected.
   */
  isZoneSelected() {
    return this.currentSelection !== null;
  }

  /**
   * Callback for add button. Will build a new child list and submit to backend.
   */
  addChild() {
    this.children.push({label: null, raw: this.currentSelection});
    this._guiZoneService.saveList(this.affectedZone, this.children, false)
      .subscribe(() => {
        this._notification.success('GUI Zone added', 'GUI Zone was successfully added as child');
        this.afterAdd.emit();
        this._activeModal.close();
      });
  }

  /**
   * Closes the modal
   */
  close() {
    this._activeModal.close();
  }

  /**
   * Builds the list of selectable zones. Zones are selectable if they are not included in
   *  - parent list: To avoid circular dependencies between zones (zone are hierarchical organized)
   *  - child list: To avoid adding a zone several times
   * as well as they are not the zone which will get the new child zone.
   *
   * @returns {SelectItem[]} List of applicable zones
   */
  private buildSelectableZones(): SelectItem[] {
    const items: SelectItem[] = [];
    this.availableZones.forEach((zone: SelectItem) => {
      if (!this.isInParent(zone) && !this.isInChildren(zone) && !this.isAffectedZone(zone)) {
        items.push(zone);
      }
    });

    return items;
  }

  /**
   * Checks whether a zone is identical the one getting the new child.
   *
   * @param {SelectItem} zone Zone to be checked
   * @returns {boolean} true if equal to affected zone
   */
  private isAffectedZone(zone: SelectItem) {
    return (zone.label === this.affectedZone.name) && (zone.value === this.affectedZone._links.self.href);
  }

  /**
   * Checks whether a zone is part of the parent list
   *
   * @param {SelectItem} zone Zone to be checked
   * @returns {boolean} true if zone is part of parent list
   */
  private isInParent(zone: SelectItem): boolean {
    return this.isInList(this.parents, zone);
  }

  /**
   * Checks whether a zone is part of the child list
   *
   * @param {SelectItem} zone Zone to be checked
   * @returns {boolean} true if zone is part of child list
   */
  private isInChildren(zone: SelectItem): boolean {
    return this.isInList(this.children, zone);
  }

  /**
   * Checks if a zone is part of list.
   *
   * @param {ListItem[]} list List to search in
   * @param {SelectItem} zone Zone to be checked for
   * @returns {boolean} true if zone is included in list
   */
  private isInList(list: ListItem[], zone: SelectItem) {
    let foundItem = list.find((item) => {
      return (item.label === zone.label) && (item.raw === zone.value);
    });
    return undefined !== foundItem;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/gui-zone/components/add-gui-zone/add-gui-zone.component.ts